// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"1049dc70","453":"159e3252"}[chunkId] + ".chunk.js";
};